import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'niceTimeFormater' })
export class NiceTimePipe implements PipeTransform {
    transform(milliseconds: number, showZeroUnits: boolean = false): string {
        if (!milliseconds) return '0min';
        
        const hours = Math.floor(milliseconds / 3600000);
        const minutes = Math.floor((milliseconds % 3600000) / 60000);
        const seconds = Math.floor((milliseconds % 60000) / 1000);
        
        let result = '';
        
        if (hours > 0 || (showZeroUnits && hours === 0)) {
          result += `${hours}h `;
        }
        
        if (minutes > 0 || hours > 0 || (showZeroUnits && minutes === 0)) {
          result += `${minutes}min `;
        }
        
        if (seconds > 0 || (showZeroUnits)) {
          result += `${seconds}s`;
        }
        
        return result.trim();
      }
}
